import { useState } from 'react';
import { withAsyncBoundary } from '@toss/async-boundary';
import { useBooleanState } from '@toss/react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { match, P } from 'ts-pattern';
import { usePaymentCustomerName } from '../../../services';
import { BusinessPayment } from '../../../types/PaymentTypes';
import { ConfirmBusinessEmail } from './components/ConfirmBusinessEmail';
import { PayplePayBusinessPayment, TossPayBusinessPayment } from './components/PayBusinessPayment';
import { BusinessPaymentLayout } from './BusinessPaymentLayout';
import S from './BusinessPayments.module.scss';
export const _BusinessPayments = () => {
  const router = useRouter();
  const paymentHashId = (router.query.id ?? '').toString();
  const {
    t
  } = useTranslation(['business']);
  const [isInvalidEmail] = useState(false);
  const [isInvalidPage, setInvalidPage] = useBooleanState(false);
  const [businessPayment, setBusinessPayment] = useState<BusinessPayment>();
  const productName = businessPayment?.productType === 0 ? t('business:businessPage.productType.normal') : t('business:businessPage.productType.premium');
  const {
    data: businessName,
    isFetched: isBusinessNameFetched
  } = usePaymentCustomerName(paymentHashId, {
    enabled: !!paymentHashId
  });
  if (!isBusinessNameFetched || !businessName || isInvalidPage || !paymentHashId) {
    return <BusinessPaymentInvalidPage />;
  }
  const props = {
    businessName,
    paymentHashId,
    productName,
    businessPayment
  };
  return <>
      {match(businessPayment).with(P.nullish, () => <ConfirmBusinessEmail paymentHashId={paymentHashId} businessName={businessName} isInvalidEmail={isInvalidEmail} onInvalidPage={setInvalidPage} onSetPaymentInfo={setBusinessPayment} />)

    // @ts-ignore
    .with({
      currency: 'KRW'
    }, () => <TossPayBusinessPayment {...props} />).with({
      currency: 'USD'
    }, () =>
    // @ts-ignore
    <PayplePayBusinessPayment {...props} />).otherwise(() =>
    // @ts-ignore
    <PayplePayBusinessPayment {...props} />)}
    </>;
};
export const BusinessPaymentInvalidPage = () => {
  const {
    t
  } = useTranslation(['business']);
  return <BusinessPaymentLayout title="" data-sentry-element="BusinessPaymentLayout" data-sentry-component="BusinessPaymentInvalidPage" data-sentry-source-file="BusinessPayments.tsx">
      <div className={S.page_content}>
        {t('business:business_payments_invalid_page')}
      </div>
    </BusinessPaymentLayout>;
};
export const BusinessPayments = withAsyncBoundary(_BusinessPayments, {
  rejectedFallback: () => <BusinessPaymentInvalidPage />,
  pendingFallback: <></>
});